<template>
  <div class="online-banking">
    <v-layout row wrap justify-center v-if="onlineLoading" class="online-loading">
      <div class="loader">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
    </v-layout>
    <div v-else>
      <v-layout row wrap justify-center v-if="!banking">
        <v-flex xs12>
          <h2 class="text-xs-center mb-2">Are you an existing online banking client?</h2>
        </v-flex>
        <v-flex shrink>
          <v-btn @click="banking = true" color="#0C2B4A">Yes</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn color="#0C2B4A" to="/signup?account=banking">No</v-btn>
        </v-flex>
        <v-flex xs12>
          <h3 class="text-xs-center mt-3">
            Please note, if you have online banking and have already enrolled in MY ALERUS, click
            <span>
              <router-link to="/logoff">here</router-link>
            </span> to log in.
          </h3>
        </v-flex>
      </v-layout>
      <v-form v-else ref="onlineBanking" class="mb-4">
        <v-container class="pa-0 mt-4">
          <h2>To help us identify you, please provide the following information.</h2>
          <v-layout row wrap mt-2>
            <v-flex xs12 sm6>
              <div class="Input__inputLabel___nQolz">First Name</div>
              <v-text-field
                :rules="[rules.required]"
                solo
                autocomplete="new-first"
                v-model="bankingInfo.first"
                placeholder="First Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="Input__inputLabel___nQolz">Last Name</div>
              <v-text-field
                :rules="[rules.required]"
                solo
                autocomplete="new-last"
                v-model="bankingInfo.last"
                placeholder="Last Name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="Input__inputLabel___nQolz">Email Address</div>
              <v-text-field
                :rules="[rules.required, rules.email]"
                solo
                autocomplete="new-email"
                v-model="bankingInfo.email"
                placeholder="Email Address"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <div class="Input__inputLabel___nQolz">Social Security Number</div>
              <v-text-field
                solo
                autocomplete="new-ssn"
                v-model="bankingInfo.ssn"
                placeholder="Social Security Number"
                mask="###-##-####"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <div class="Input__inputLabel___nQolz">Date of Birth</div>
              <v-text-field
                solo
                autocomplete="new-dob"
                v-model="bankingInfo.dob"
                placeholder="MM/DD/YYYY"
                mask="##/##/####"
                required
                :rules="[rules.required, rules.dob]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <h2>Please create a new username and password.</h2>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <div class="Input__inputLabel___nQolz">Username</div>
              <v-text-field
                autocomplete="new-user"
                solo
                v-model="bankingInfo.username"
                placeholder="Username"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6></v-flex>
            <v-flex xs12 sm6>
              <div class="Input__inputLabel___nQolz">Password</div>
              <v-text-field
                :rules="[rules.required, rules.min, rules.upper, rules.lower, rules.number]"
                type="password"
                autocomplete="new-password"
                solo
                v-model="bankingInfo.password"
                placeholder="Password"
                persistent-hint
                hint="At least 8 characters, 1 number, 1 lowercase and 1 uppercase letter"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="Input__inputLabel___nQolz">Confirm Password</div>
              <v-text-field
                solo
                autocomplete="new-pass2"
                :rules="[rules.required, rules.min, rules.match]"
                v-model="bankingInfo.password2"
                placeholder="Confirm Password"
                required
                type="password"
                @keyup.enter="preSignUp"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-btn color="#0C2B4A" class="form-submit ma-0" @click="preSignUp">Submit</v-btn>
          <v-flex>
            <div v-if="error" class="migrationError mt-4" v-html="error" />
          </v-flex>
        </v-container>
      </v-form>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" scrollable width="600px" persistent>
          <v-card>
            <v-card-text class="pa-0">
              <privacy />
            </v-card-text>
            <v-card-actions>
              <v-btn color="#0C2B4A" @click="printMe">Print</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="#0C2B4A" @click="getAnswer(false)">Decline</v-btn>
              <v-btn color="#0C2B4A" @click="getAnswer(true)">Accept</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>
  </div>
</template>



<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapState } from "vuex";
import Dashboard from "@/components/Dashboard.vue";
import Privacy from "@/components/Privacy.vue";
import VueHtmlToPaper from "@/plugins/print";
export default {
  name: "OnlineBanking",
  components: {
    Dashboard,
    Privacy
  },
  mixins: [VueHtmlToPaper],
  data() {
    return {
      onlineLoading: false,
      dialog: false,
      userResponse: true,
      terms: false,
      rules: {
        required: v => !!v || "Required",
        min: v => v.length >= 8 || "Min 8 characters",
        upper: v => /[A-Z]/.test(v) || "Must include uppercase letter",
        lower: v => /[a-z]/.test(v) || "Must include lowercase letter",
        number: v => /[0-9]/.test(v) || "Must include number",
        email: v => /.+@.+/.test(v) || "Invalid email address",
        dob: v =>
          String(v).length == 8 ||
          "Please enter a valid birth date with format MM/DD/YYYY",
        match: v =>
          this.bankingInfo.password === this.bankingInfo.password2 ||
          "Passwords don't match"
      },
      banking: false,
      bankingInfo: {
        first: "",
        last: "",
        email: "",
        ssn: "",
        dob: "",
        username: "",
        password: "",
        password2: ""
      },
      error: ""
    };
  },
  computed: {
    ...mapState("user", ["step"])
  },
  async created() {},
  methods: {
    newUserAtts() {
      return Object.entries(this.extraInfo).map(([key, value]) => {
        return {
          Name: key,
          Value: value
        };
      });
    },
    printMe() {
      if (this.step === 1) {
        this.htmlToPaper("consent");
      } else {
        this.htmlToPaper("print");
      }
    },
    async formatAtts(atts) {
      return Object.entries(atts).map(([key, value]) => {
        return {
          Name: key,
          Value: value
        };
      });
    },
    async sendDetails() {
      let newData = {
        ssn: this.bankingInfo.ssn,
        dob: this.bankingInfo.dob,
        lastName: this.bankingInfo.last,
        accountType: "existingBanking"
      };

      return this.formatAtts(newData);
    },
    getAnswer(val) {
      if (val) {
        if (this.step === 2) {
          this.$store.commit("user/increaseStep");
          this.userResponse = true;
          this.dialog = false;
          this.signUp();
        } else {
          this.$store.commit("user/increaseStep");
        }
      } else {
        this.onlineLoading = false;
        this.dialog = false;
        this.userResponse = false;
      }
    },
    preSignUp() {
      if (!this.$refs.onlineBanking.validate()) return;
      this.signUp();
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      // this.logger.error(this.error);
    },
    async signUp() {
      this.error = "";
      if (this.terms && !this.userResponse) {
        this.dialog = true;
        return;
      }
      let user = {
        attributes: {}
      };

      //Capitalize first and last names
      let firstName = this.bankingInfo.first.toLowerCase();
      let lastName = this.bankingInfo.last.toLowerCase();

      //set user atts
      user.username = this.bankingInfo.username.toLowerCase();
      user.password = this.bankingInfo.password;
      user.attributes.email = this.bankingInfo.email.toLowerCase();
      user.attributes["custom:userStatus"] = "true";
      user.attributes["name"] = this.bankingInfo.ssn;
      user.attributes["custom:product"] = "existingBanking";
      user.attributes["given_name"] =
        firstName.charAt(0).toUpperCase() + firstName.slice(1);
      user.attributes["family_name"] =
        lastName.charAt(0).toUpperCase() + lastName.slice(1);
      user.attributes["custom:dateofbirth"] = this.bankingInfo.dob;
      //   user.attributes.phone_number = `+${this.country}${this.phone}`;
      user.attributes["custom:userFlags"] =
        '{"isAdmin":false,"isAlerus":false,"isFCMM":false,"isICapital":false,"isKeating":false,"isMERS":false,"isEnvestnet":false,"OCEAccess":false,"CFUAccess":false,"partAccess":false}';
      //set validation data
      // user.validationData = details;

      // Add terms after accepted
      if (this.terms && this.userResponse) {
        user.attributes["custom:agreedterms"] = new Date().toISOString();
      }

      // set loading to true
      this.onlineLoading = true;

      this.$Amplify.Auth.signUp(user)
        .then(data => {
          // this.logger.info("sign up success");
          AmplifyEventBus.$emit("localUser", data.user);
          if (data.userConfirmed === false) {
            return AmplifyEventBus.$emit("authState", "confirmSignUp");
          } else {
            this.$Amplify.Auth.signIn(user.username, user.password)
              .then(newUser => {
                this.$store.commit("user/setPassword", user.password);
                this.$store.commit("user/setLoading", true);
                this.$router.push("/");
                return AmplifyEventBus.$emit("authState", "signedIn");
              })
              .catch(err => {
                // set loading to false
                this.onlineLoading = false;
                return AmplifyEventBus.$emit("authState", "signedOut");
                console.log(err);
              });
          }
        })
        .catch(e => {
          // set loading to false
          this.onlineLoading = false;
          if (
            e.message === "PreSignUp failed with error please accept terms."
          ) {
            this.dialog = true;
            this.terms = true;
          } else if (
            e.message === "PreSignUp failed with error User not found."
          ) {
            this.setError(
              "We are unable to validate your information, please call our client service center for assistance."
            );
          } else if (
            e.message ===
            "PreSignUp failed with error User not found in online banking."
          ) {
            this.setError(
              "We are unable to validate the information you entered, please verify and re-enter or <a href='/signup?account=banking'>create a new account</a> from the login page."
            );
          } else {
            this.setError(e);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.online-banking {
  h2 {
    font-size: 1.25rem;
    font-weight: initial;
    margin-top: 0.5rem;
  }
  h3 {
    font-weight: initial;
    font-size: 1.1rem;
  }
  .v-btn {
    color: #fff !important;
  }
}

.online-loading {
  margin: 0 auto;
  max-width: 800px;
  .loader {
    width: 50%;
  }
}
</style>
